
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.813 6.852c-.948.849-2.045 1.273-3.29 1.273-.854 0-1.518-.177-1.992-.531-.468-.36-.703-.86-.703-1.5 0-.469.167-.888.5-1.258.333-.37.813-.643 1.438-.82v-.079c-1.12-.296-1.68-.89-1.68-1.78 0-.527.26-.956.781-1.29.526-.333 1.248-.5 2.164-.5.657 0 1.45.143 2.383.43V2.14h-.797C5.29 1.375 4.72.992 3.907.992c-.407 0-.74.107-1 .32-.261.214-.391.514-.391.899 0 .463.156.802.468 1.016.313.208.86.312 1.641.312h.445v.844h-.703c-.687 0-1.206.122-1.554.367-.35.24-.524.596-.524 1.07 0 .922.565 1.383 1.695 1.383.855 0 1.649-.305 2.383-.914l.446.563z","fill":"currentColor"}})])
          )
        }
      }
    